import { Cross2Icon } from '@radix-ui/react-icons'
import { Dialog, Flex } from '@radix-ui/themes'
import styles from '../neon-wallets.module.scss'

interface Props {
  icon: React.ReactNode
  /** `<b>` parts glow green, as in the Bull's Eye title. */
  title: React.ReactNode
  subtitle: string
}

export const NeonDialogHeader: React.FC<Props> = ({
  icon,
  title,
  subtitle
}) => (
  <Flex
    align='center'
    gap='3'
    className={styles.header}
  >
    <span className={styles.headerIcon}>{icon}</span>
    <Flex
      direction='column'
      gap='1'
      minWidth='0'
    >
      <Dialog.Title
        mb='0'
        className={styles.headerTitle}
      >
        {title}
      </Dialog.Title>
      <Dialog.Description className={styles.headerSubtitle}>
        {subtitle}
      </Dialog.Description>
    </Flex>
    <Dialog.Close>
      <button
        type='button'
        className={styles.closeButton}
        aria-label='Close'
      >
        <Cross2Icon />
      </button>
    </Dialog.Close>
  </Flex>
)
